<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增系统</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="system_code" label="系统编号" min-width="100"></el-table-column>
            <el-table-column prop="system_name" label="系统名称" min-width="100"></el-table-column>
            <el-table-column prop="description" label="系统描述" min-width="100"></el-table-column>
            <el-table-column prop="icon" label="图标" min-width="100">
                <template slot-scope="scope">
                    <i class="iconfont" :class="scope.row.icon"></i>
                </template>
            </el-table-column>
            <el-table-column prop="sort_order" label="排序" min-width="100"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ddd"
                    :active-value="1" :inactive-value="0" @change="ToggleSystem(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="update_time" label="创建时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="系统项目" placement="top-start">
                        <i class="NavIcon el-icon-tickets"@click="ToggleSysType(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        
                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <AdminSysType :visible="SysTypeBlon" :rowData="RowData" @cancel="SysTypeBlon = false" />
        <el-dialog :title="Type=='Add'?'新增系统':'修改系统'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius">
            <div class="DigItem" v-if="Type =='Add'">
                <div class="DigItemTit">系统编号：</div>
                <el-input class="Wid" size="medium" placeholder="请输入系统编号" v-model="NewData.system_code"></el-input>
            </div>
            
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">系统名称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入系统名称" v-model="NewData.system_name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">编号前缀：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入编号前缀" v-model="NewData.number_prefix"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">系统联系人：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入系统联系人" v-model="NewData.lxr_name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">联系号码：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入联系号码" v-model="NewData.lxr_phone"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">图标：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入图标" v-model="NewData.icon"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">排序：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入排序" v-model="NewData.sort_order"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">评审修改次数：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入评审修改次数" v-model="NewData.expert_score_edit_limit"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">审查意见：</div>
                    <el-switch class="Wid" v-model="NewData.is_yijian" active-color="#13ce66" inactive-color="#ddd"
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">系统描述：</div>
                <el-input class="Wid" size="medium" type="textarea" :rows="2" placeholder="请输入系统描述" v-model="NewData.description"></el-input>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">系统状态：</div>
                    <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">未满分原因：</div>
                    <el-switch class="Wid" v-model="NewData.review_reason_required" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">是否点评项目：</div>
                    <el-switch class="Wid" v-model="NewData.is_dianping" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div class="DigItem" v-if="NewData.is_dianping">
                <div class="DigItemTit">点评描述：</div>
                <el-input class="Wid" size="medium" type="textarea" :rows="2" placeholder="请输入点评描述" v-model="NewData.dianping_ms"></el-input>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">是否有加分项：</div>
                    <el-switch class="Wid" v-model="NewData.bonus_feature_enabled" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0" v-if="NewData.bonus_feature_enabled">
                    <div class="DigItemTit">加分最大值：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入加分最大值" v-model="NewData.bonus_max_score"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">设置组长：</div>
                    <el-switch class="Wid" v-model="NewData.leader_setting" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0" @change="Toggleleader()"/>
                </div>
                <div class="DigItem MarBom0" v-if="NewData.leader_setting">
                    <div class="DigItemTit">组员评审查看：</div>
                    <el-switch class="Wid" v-model="NewData.leader_can_view_others" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0" v-if="NewData.leader_setting">
                    <div class="DigItemTit">组长总结填写：</div>
                    <el-switch class="Wid" v-model="NewData.leader_summary_required" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    system_code:"",
                    system_name:"",
                    icon:"",
                    description:"",
                    sort_order:"",
                    status:0,
                    leader_setting:0,
                    leader_can_view_others:0,
                    review_reason_required:0,
                    leader_summary_required:0,
                    bonus_feature_enabled:0,
                    bonus_max_score:0,
                    expert_score_edit_limit:1,
                    is_dianping:0,
                    is_yijian:"",
                    lxr_name:"",
                    lxr_phone:"",
                    dianping_ms:"",
                    number_prefix:"",
                },
                SysTypeBlon:false,
                RowData:{},
            };
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/system/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.system_name = row.system_name;
                    this.NewData.icon = row.icon;
                    this.NewData.description = row.description;
                    this.NewData.sort_order = row.sort_order;
                    this.NewData.status = row.status;
                    this.NewData.leader_setting = row.leader_setting;
                    this.NewData.leader_can_view_others = row.leader_can_view_others;
                    this.NewData.review_reason_required = row.review_reason_required;
                    this.NewData.leader_summary_required = row.leader_summary_required;
                    this.NewData.bonus_feature_enabled = row.bonus_feature_enabled;
                    this.NewData.bonus_max_score = row.bonus_max_score;
                    this.NewData.expert_score_edit_limit = row.expert_score_edit_limit;
                    this.NewData.is_dianping = row.is_dianping;
                    this.NewData.is_yijian = row.is_yijian;
                    this.NewData.lxr_name = row.lxr_name;
                    this.NewData.lxr_phone = row.lxr_phone;
                    this.NewData.dianping_ms = row.dianping_ms;
                    this.NewData.number_prefix = row.number_prefix;
                }else{
                    this.Type='Add';
                    this.NewData.expert_score_edit_limit = 1;
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                this.NewData.path = "/ModelIndex";
                if(this.Type=='Add'){
                    this.$post('/admin/system/save',this.NewData).then(res=>{
                        if(res){
                            this.$message.success("添加成功");
                            this.ReSetPage();
                        }
                    })
                }else{
                    this.$put('/admin/system/update/'+this.NewData.id,this.NewData).then(res=>{
                        if(res){
                            this.$message.success("修改成功");
                            this.GetData();
                        }
                    })
                }
                this.$Tools.ResetData(this.NewData)
            },
            Toggleleader(row) {
                if(!this.NewData.leader_setting){
                    this.NewData.leader_can_view_others = 0;
                    this.NewData.leader_summary_required = 0;
                }
            },
            ToggleSysType(row){
                this.RowData = row;
                this.SysTypeBlon = true;
            },
            ToggleSystem(row){
                this.$post('/admin/system/toggleStatus',{
                    ids:[row.id],
                    status:row.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            Delete(id) {
                this.$confirm("此操作将永久删除该系统, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/system/delete/'+id).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
